import React from 'react';

import {isEmpty, keys} from "lodash";

const isDev = (process.env.NODE_ENV == 'development');

/**
 * LloydCartFields - generates HTML form fields for
 * the entire shopping cart (all items). Mostly just
 * loops through FieldsForItem.
 *
 * Used by EnabledFormBottom and SubmittingFormBottom
 */
export default function LloydCartFields({lloydCart}) {
  if (!lloydCart.items) {
    console.error("LloydCartFields: no lloydCart.items")
    return null;
  }

  let cartItems = lloydCart.items.toArray();

  // Shows only when cart items are present.
  if (isEmpty(cartItems))
    return null;

  // FIXME snake_case
  return <div id="lloyd-item-section-bottom-summary">
    {cartItems.map((cartItem, n) =>
      <FieldsForItem
        key={cartItem.extended_part_number || n}
        cartItem={cartItem}
      />)
    }
  </div>
}

function FieldsForItem({cartItem}) {
  /** @type {ItemFormAdapter} */
  let formAdapter = cartItem.formFields();
  let fields = formAdapter.contents();
  let prefix = formAdapter.prefix;

  let type = "hidden"; // isDev ? 'text' : 'hidden';

  // cart_item1[field] where field in product_id, quantity, vehicle_id, vehicle_fitment_id, suggested_brand_shipper_id
  return <div>
    {keys(fields).map(name => {
        return <input key={name}
          type={type} name={`${prefix}[${name}]`}
          readOnly={true} value={fields[name] || ""}/>
      }
    )}
  </div>
}
